import ApiService from "./ApiService"
import appConfig from '../configs/app.config'

export async function getReports(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'mobreportnew',
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}


// MOBREPORT
// getsavelastanalyzeresultsnew?start_date=20250701&end_date=20250731
export async function getMobReportPano(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getsavelastanalyzeresults?start_date=' + data.start_date + '&end_date=' + data.end_date,
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}
// getsavelastanalyzeresultsnew?start_date=20250701&end_date=20250731
export async function getMobReportDetail(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'gettransactiondetailresultnew?trans_id=' + data,
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}

// DSA resimleri çekilenler
export async function getDsaResultReport(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getdsaresultsnew?date=' + data.date + '&type=' + data.type,
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}

// Dolap resimleri çekilenler
export async function getPicosResultReport(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getpicosresultsnew?date=' + data.date + '&type=' + data.type,
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}

// Dolap resimleri çekilenler
export async function getPicosResultReportAll(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getpicosallresultsnew?date=' + data.date + '&type=' + data.type,
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}

// Dolap resimleri çekilenler
export async function getPivotRafPayiResultReport(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getshelfshareresultsnew?date=' + data.date + '&type=' + data.type,
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}

// Dolap resimleri çekilenler
export async function getDisplayResultNew(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getdisplayresultsnew?date=' + data.date + '&type=' + data.type,
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}

// Dolap resimleri çekilenler
export async function getWatersBulunurluk(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getwatersavailabilityreport?date=' + data.date + '&type=' + data.type,
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        responseType: data.type === 'xlsx' ? 'arraybuffer' : 'json',
        data
    })
}


// Temsilci Ziyaret İstatistiklerini döndürür
export async function getTransactionsSSM(data) {
    return ApiService.fetchData({
        url: 'https://labeldnn.neocortexs.com/servis',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}

// KPI Skorları döndürür
export async function getKpiScoreVisits(data) {
    return ApiService.fetchData({
        url: 'https://labeldnn.neocortexs.com/servis',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}

// Genel Raporları Döndürür
export async function getGeneralReports(data) {
    return ApiService.fetchData({
        url: 'https://labeldnn.neocortexs.com/servis',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}

// Genel Servis istekleri için kullanılır
export async function getVariableService(data) {
    return ApiService.fetchData({
        url: 'https://labeldnn.neocortexs.com/servis',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}

export async function getKPIscoreTrends(params) {
    return ApiService.fetchData({
        url: '/stats/kpi_trends',
        method: 'get',
        params
    })
}


export async function getKPIscorePer(params) {
    return ApiService.fetchData({
        url: '/stats/kpi_per',
        method: 'get',
        params
    })
}


/*
Get competition questions for a specific competition
ÖRNEK RESPONSE
{
    "Status": "Normal",
    "Content": [
        {
            "q_type_id": 8,
            "question_type": "Planogram Uygunlu\u011fu",
            "questions": [
                {
                    "sequence_no": 1,
                    "question_text": "Ayni blok icerisinde t\u00fcm markalar temas halinde bulunmasa da, yukaridan asagida minimum 3 rafta activia markasi, minimum alt 3 rafta Kids, Yoshake, Danette \u00fcr\u00fcnleri konumlandinildi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 2,
                    "question_text": "T\u00fcm Activia \u00fcr\u00fcnlerinin temas halinde olmasi ve aralarina baska bir marka girsi olmadan rafta konumlandinilmasi saglandi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 3,
                    "question_text": "Activia 4*100 veya Big Cup veya 8*100 \u00fcr\u00fcnlerinin temas halinde ve yan yang bir b\u00fct\u00fcn olarak konumlandinilmasi saglandi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 4,
                    "question_text": "Activia Bowl veya Mix&Go veya Mix&Go MP \u00fcr\u00fcnlerinin temas ve yan yana halinde bir b\u00fct\u00fcn olarak konumlandirilmasi saglandi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 5,
                    "question_text": "Activia Shake veya Shot veya Shot MP \u00fcr\u00fcnlerinin temas halinde ve yan yana bir b\u00fct\u00fcn olarak konumlandinlmasi saglandi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 6,
                    "question_text": "Activia Spoonable \u00fcr\u00fcnleri i\u00e7in Kilavuzda belirtildigi sekilde \u00fcr\u00fcn stralamasina g\u00f6re yerlestirmeler yapildi mi? Eksik \u00fcr\u00fcn olsa bile \u00fcr\u00fcn\u00fcn cesidindeki siralama ayni olmali",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 7,
                    "question_text": "Activia Bowl \u00fcr\u00fcnleri icin Kilavuzda belirtildigi sekilde \u00fcr\u00fcn siralamasina g\u00f6re yerlestirmeler yapildi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 8,
                    "question_text": "Activia Shot \u00fcr\u00fcnleri icin Kilavuzda belirtildigi sekilde \u00fcr\u00fcn siralamasina g\u00f6re yerlestirmeler yapildi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 9,
                    "question_text": "Alpro \u00fcr\u00fcnleri i\u00e7in kilavuzda belirtildigi \u00fczere orijinal - sekersiz - aromali - 500 Ml - 250 ml seklinde kategori ayrimi vapildi mi?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 10,
                    "question_text": "Alpro Orijinal \u00fcr\u00fcnleri i\u00e7in Kilavuzda belirtildigi sekilde \u00fcr\u00fcn siralamasina g\u00f6re yerlestirmeler yapildi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 11,
                    "question_text": "Alpro Sekersiz \u00fcr\u00fcnleri i\u00e7in Kilavuzda belirtildigi sekilde \u00fcr\u00fcn siralamasina g\u00f6re yerlestirmeler yapildi mi?\n",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 12,
                    "question_text": "Alpro Aromali \u00fcr\u00fcnleri i\u00e7in Kilavuzda belirtildigi sekilde \u00fcr\u00fcn siralamasina g\u00f6re yerlestirmeler yapildi mi?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                }
            ]
        },
        {
            "q_type_id": 9,
            "question_type": "\u0130kincil Sergileme(Te\u015fhir)",
            "questions": [
                {
                    "sequence_no": 1,
                    "question_text": "Herhangi (UHT+FRESH) bir kategoride minimum 6 \u00fcr\u00fcn olacak \u015fekilde yap\u0131lan te\u015fhir var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": 5,
                            "minCount": 1
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 2,
                    "question_text": "Alpro markal\u0131 \u00fcr\u00fcnlerden minimum 6 \u00fcr\u00fcn olacak \u015fekilde te\u015fhir var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 5,
                            "value": 1,
                            "maxCount": 1,
                            "minCount": 1
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 3,
                    "question_text": "Krema markal\u0131 \u00fcr\u00fcnlerden minimum 6 \u00fcr\u00fcn olacak \u015fekilde te\u015fhir var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 5,
                            "value": 1,
                            "maxCount": 1,
                            "minCount": 1
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                }
            ]
        },
        {
            "q_type_id": 10,
            "question_type": "POP Kullan\u0131m\u0131",
            "questions": [
                {
                    "sequence_no": 1,
                    "question_text": "So\u011futucu i\u00e7erisinde Activia Kategorisi Ye\u015fil Blok i\u00e7in POP Yerle\u015fimi var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": 10,
                            "minCount": 2
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 2,
                    "question_text": "S\u00fct reyonunda Alpro Kategorisi i\u00e7in POP Yerle\u015fimi var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": 10,
                            "minCount": 2
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                },
                {
                    "sequence_no": 3,
                    "question_text": "So\u011futucu \u00e7evresinde Di\u011fer (YoShake) te\u015fhiri var m\u0131 ?",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 1,
                            "value": 1,
                            "maxCount": 2,
                            "minCount": 1
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                }
            ]
        },
        {
            "q_type_id": 11,
            "question_type": "Fiyat Etiketi",
            "questions": [
                {
                    "sequence_no": 3,
                    "question_text": "T\u00fcm \u00fcr\u00fcnlerin fiyat etiketleri var m\u0131 ? Fiyat etiketi sku \u00e7e\u015fidi baz\u0131nda tekil kontrol edilmelidir. Rafta bulunan herhangi bir \u00e7e\u015fit skunun etiketi yok ise puan al\u0131namaz",
                    "answer_type": "enum",
                    "answer_options": [
                        {
                            "id": 1,
                            "key": "Evet",
                            "point": 2,
                            "value": 1,
                            "maxCount": null,
                            "minCount": null
                        },
                        {
                            "id": 2,
                            "key": "Hay\u0131r",
                            "point": 0,
                            "value": 0,
                            "maxCount": null,
                            "minCount": null
                        }
                    ]
                }
            ]
        }
    ]
}
*/
export async function getCompetitionQuestions(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getcompetitionquestions',
        method: 'get',
        headers: { 'Content-Type': 'application/json' },
        data
    })
}

/**
 * Get Dashboard Results API
 * @endpoint GET /getdashboardresults?start_date={start_date}&end_date={end_date}
 * @headers {
 *   token: string,
 *   project_id: string,
 *   client_type: "web" | "mob"
 * }
 * @queryParams {
 *   start_date: string,  // Format: YYYYMMDD (örn: "20251001")
 *   end_date: string     // Format: YYYYMMDD (örn: "20251231")
 * }
 * @response {
 *   Status: "Normal" | "Error",
 *   Content: {
 *     total_visits: number,
 *     completed_visits: number,
 *     pending_visits: number,
 *     kpi_scores: object,
 *     ...
 *   }
 * }
 */
export async function getDashboardResults(data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'getdashboardresults?start_date=' + data.start_date + '&end_date=' + data.end_date,
        method: 'get',
        headers: { 'Content-Type': 'application/json' }
    })
}